import { useState } from "react";
import { faqItems } from "@/mocks/categories";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-2">
          Frequently Asked Questions
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8">
          Everything you need to know about CSSBuy spreadsheets and shopping agents.
        </p>
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="border border-foreground-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors duration-150"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIndex === idx ? "subtract" : "add"}-line text-foreground-500 text-lg transition-transform duration-200`}></i>
                </span>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}